import React from 'react'
import PropTypes from 'prop-types'

export const NavCollapseButton = ({ onClick, active }) => {
  if (active) {
    return <XMarkIcon />
  }
  return <BarIcon />

  function XMarkIcon() {
    return (
      <i className="cursor-pointer fas fa-xmark" style={{ fontSize: '26px', color: '#A5ADBA' }} onClick={onClick} />
    )
  }

  function BarIcon() {
    return (
      <i className="cursor-pointer far fa-bars fa-lg" style={{ color: '#A5ADBA' }} onClick={onClick} />
    )
  }
}

NavCollapseButton.propTypes = {
  onClick: PropTypes.func,
  active: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/NavCollapseButton.js